import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { INACTIVE_GRAY } from '../../colors';
import { isDefined } from '../../helpers/defined';
import { userSelectNoneStyle } from '../../tokens/user-select';
import { baseEllipsisStyle } from '../../tokens/ellipsis';
import { baseHyphensStyle } from '../../tokens/hyphens';
import { textAlign } from '../../style/text-align';
import { wordBreak } from '../../style/word-break';
export var baseTypographyMixin = css(_templateObject(), function (_ref) {
  var shadowed = _ref.shadowed;
  return shadowed ? "text-shadow: 0 2px 4px rgba(63, 65, 68, 0.3);" : '';
}, function (_ref2) {
  var muted = _ref2.muted;
  return muted ? "color: " + INACTIVE_GRAY + ";" : '';
}, function (_ref3) {
  var strong = _ref3.strong,
      bold = _ref3.bold;
  return strong || bold ? "font-weight: 600;" : '';
}, function (_ref4) {
  var italic = _ref4.italic;
  return italic ? "font-style: italic;" : '';
}, function (_ref5) {
  var value = _ref5.textAlign;
  return isDefined(value) ? textAlign(value) : '';
}, function (_ref6) {
  var value = _ref6.wordBreak;
  return isDefined(value) ? wordBreak(value) : '';
}, function (_ref7) {
  var textAlignCenter = _ref7.textAlignCenter;
  return textAlignCenter ? "text-align: center;" : '';
}, function (_ref8) {
  var textAlignLeft = _ref8.textAlignLeft;
  return textAlignLeft ? "text-align: left;" : '';
}, function (_ref9) {
  var textAlignRight = _ref9.textAlignRight;
  return textAlignRight ? "text-align: right;" : '';
}, function (_ref10) {
  var userSelectNone = _ref10.userSelectNone;
  return userSelectNone ? userSelectNoneStyle : '';
}, function (_ref11) {
  var ellipsis = _ref11.ellipsis;
  return ellipsis ? baseEllipsisStyle : '';
}, function (_ref12) {
  var hyphens = _ref12.hyphens;
  return hyphens ? baseHyphensStyle : '';
});
export var baseTypographyKeys = ['color', 'negative', 'inverse', 'shadowed', 'muted', 'strong', 'bold', 'italic', 'textAlign', 'wordBreak', 'textAlignCenter', 'textAlignLeft', 'textAlignRight', 'userSelectNone', 'ellipsis', 'hyphens'];